__turbopack_context__.v({
  "button": "DomainFind-module__VlU5ja__button",
  "heading": "DomainFind-module__VlU5ja__heading",
  "input": "DomainFind-module__VlU5ja__input",
  "inputMobile": "DomainFind-module__VlU5ja__inputMobile",
  "linkButton": "DomainFind-module__VlU5ja__linkButton",
  "searchBox": "DomainFind-module__VlU5ja__searchBox",
  "searchBoxMobile": "DomainFind-module__VlU5ja__searchBoxMobile",
  "subtext": "DomainFind-module__VlU5ja__subtext",
  "wrapper": "DomainFind-module__VlU5ja__wrapper",
});
